import { render } from "./adminpower.vue?vue&type=template&id=f4289588&scoped=true"
import script from "./adminpower.vue?vue&type=script&lang=js"
export * from "./adminpower.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4289588"]])

export default __exports__